import { render, staticRenderFns } from "./ModalLookupRegisterBdm.vue?vue&type=template&id=73816835&"
import script from "./ModalLookupRegisterBdm.vue?vue&type=script&lang=js&"
export * from "./ModalLookupRegisterBdm.vue?vue&type=script&lang=js&"
import style0 from "./ModalLookupRegisterBdm.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports